import { render, staticRenderFns } from "./BriefcaseMassAddDialog.vue?vue&type=template&id=3b9d2602"
import script from "./BriefcaseMassAddDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./BriefcaseMassAddDialog.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports